import {
  type CustomWorkbookCopyBody,
  makeCustomWorkbookApi,
} from '@mathflat/domain/MakeCustomWorkbook'
import {
  type ListedWorkbook,
  type Workbook,
  workbookApi,
  type WorkbookListItem,
  type WorkbookListParams,
  type WorkbookOf,
} from '@mathflat/domain/Workbook'
import { upsertTimestampToUrl } from '@mathflat/shared/@common/utils/url/url'

import { mpEventInfo } from '@/constant'
import { SchoolSubjectGrade } from '@/dto'
import { createLatestRequestSignal } from '@/utils/axios/latestRequestSignal'
import type { CustomRequestConfigMeta } from '@/utils/axios/maxios'

// 썸네일은 같은 URL 로 다시 만들어지므로 브라우저 캐시를 피해 받는다
const withFreshThumbnail = (item: WorkbookListItem): WorkbookListItem => {
  const { workbook } = item
  if (!('thumbnailImageUrl' in workbook) || !workbook.thumbnailImageUrl) return item
  return {
    ...item,
    workbook: { ...workbook, thumbnailImageUrl: upsertTimestampToUrl(workbook.thumbnailImageUrl) },
  }
}

/**
 * @deprecated
 */
export class WorkbookController {
  private signalFor = createLatestRequestSignal('GET/workbook')

  fetchWorkbooks = async <T extends ListedWorkbook['type'] = ListedWorkbook['type']>(
    params: WorkbookListParams,
    meta?: CustomRequestConfigMeta,
  ) => {
    const { content, last } = await workbookApi.getWorkbooks(params, {
      meta: { mp_event_name: mpEventInfo.교재조회 },
      signal: this.signalFor(meta),
    })
    const workbookReponses = content.map(
      (item) => withFreshThumbnail(item) as WorkbookListItem<WorkbookOf<T>>,
    )
    return { workbookReponses, last }
  }

  fetchWorkbookDetailInfo = async (
    workbookId: Workbook['id'],
    { trackEvent = true }: { trackEvent?: boolean } = {},
  ) => {
    // 화면 진입이 아닌 판정용 조회는 "교재 수정 화면 조회" 지표를 오염시키므로 이벤트를 안 단다.
    const data = await workbookApi.getWorkbookDetail(
      workbookId,
      trackEvent ? { mp_event_name: mpEventInfo.교재수정시조회 } : undefined,
    )
    return { ...data, schoolGrade: new SchoolSubjectGrade(data) }
  }

  copyWorkbook = async (workbookId: Workbook['id'], requestBody: CustomWorkbookCopyBody) => {
    await makeCustomWorkbookApi.copyCustomWorkbook(workbookId, requestBody)
  }
}

/**
 * @deprecated
 */
export const _workbookController = new WorkbookController()
